import { Drawer, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styled from '@emotion/styled';
import Logo from './Logo';
import { navLinks, bookDemoLink, loginLink } from './nav';
import { colors, fonts } from './theme';

const DrawerContent = styled(Box)`
  width: 280px;
  max-width: 85vw;
  height: 100%;
  background: ${colors.coreBlue};
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

const DrawerTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
`;

const DrawerLink = styled.a`
  font-family: ${fonts.sans};
  font-size: 18px;
  color: ${colors.baselineWhite};
  text-decoration: none;
  padding: 14px 0;
  border-bottom: 1px solid ${colors.borderInverse};
`;

interface MobileNavProps {
  open: boolean;
  onClose: () => void;
}

export default function MobileNav({ open, onClose }: MobileNavProps) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <DrawerContent>
        <DrawerTop>
          <Logo href="/" height={24} />
          <IconButton onClick={onClose} aria-label="Close menu">
            <CloseIcon htmlColor={colors.baselineWhite} />
          </IconButton>
        </DrawerTop>
        {navLinks.map((link) => (
          <DrawerLink key={link.href} href={link.href} onClick={onClose}>
            {link.label}
          </DrawerLink>
        ))}
        <DrawerLink href={loginLink.href} onClick={onClose}>
          {loginLink.label}
        </DrawerLink>
        <DrawerLink href={bookDemoLink.href} onClick={onClose}>
          {bookDemoLink.label}
        </DrawerLink>
      </DrawerContent>
    </Drawer>
  );
}
